module.exports = __webpack_public_path__ + "img/gps-1.65debb28.png";